import React from 'react'
import PropTypes from 'prop-types'
import { PortalHeader } from 'components'
import { useCommunity } from 'utils'

const propTypes = {
  children: PropTypes.node.isRequired,
}

function CourseFlowLayout({ children }) {
  const {
    defaultBranding: { dashboardHeader },
  } = useCommunity()

  return (
    <div>
      <PortalHeader backgroundImage={dashboardHeader} />
      {children}
    </div>
  )
}

CourseFlowLayout.propTypes = propTypes

export default CourseFlowLayout
